import React, { useState } from 'react';

import {
  createStyles,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Theme,
  withStyles
} from '@material-ui/core';

import { PX } from '../../../../../src/contrib/ui';

import { IAdminEvent } from '../../../../store/admin/events/store';

import { EventHistoryRow } from './EventHistoryRow';
import { EventHistoryTotals } from './EventHistoryTotals';

const StyledTableCell = withStyles((theme: Theme) =>
  createStyles({
    body: {
      fontSize: 14
    },
    head: {
      color: theme.palette.common.white,
      fontFamily: 'DINNextLTPro-Heavy',
      fontSize: `${16 * PX}px`,
      height: `${40 * PX}px`,
      lineHeight: `${19 * PX}px`,
      paddingRight: `${24 * PX}px`,
      textShadow: `0 ${2 * PX}px ${4 * PX}px 0 rgba(0,0,0,0.5)`
    }
  })
)(TableCell);

interface IEventHistory {
  userEvents: IAdminEvent[];
}

export const EventHistory = (props: IEventHistory) => {
  const { userEvents } = props;

  const [collapsedRow, setCollapsedRow] = useState<number | undefined>();

  const onClick = (index: number) => () => setCollapsedRow(index);

  const onExpandLess = () => setCollapsedRow(-1);

  return (
    <div className="admin-layout">
      <div className="event-history admin-wrapper">
        <div className="main-container">
          <EventHistoryTotals />

          {!!userEvents && (
            <Paper elevation={1} className="paper ">
              <h3>INDEXES & HANDICAPS</h3>

              <Table>
                <colgroup>
                  {Array.from(Array(9).keys()).map(index => (
                    <col key={index} />
                  ))}
                </colgroup>
                <TableHead>
                  <TableRow>
                    <StyledTableCell align="left">DATE</StyledTableCell>
                    <StyledTableCell align="center">TYPE</StyledTableCell>
                    <StyledTableCell align="left">EVENT NAME</StyledTableCell>
                    <StyledTableCell align="center">COURSE</StyledTableCell>
                    <StyledTableCell align="center">HCP</StyledTableCell>
                    <StyledTableCell align="center">PLACE</StyledTableCell>
                    <StyledTableCell align="center">GROSS</StyledTableCell>
                    <StyledTableCell align="center">NET</StyledTableCell>
                    <StyledTableCell align="center" />
                  </TableRow>
                </TableHead>
                <TableBody>
                  {userEvents.map((item, index) => (
                    <EventHistoryRow
                      item={item}
                      key={index}
                      index={index}
                      collapsedRow={collapsedRow}
                      onExpandLess={onExpandLess}
                      onClick={onClick}
                    />
                  ))}
                </TableBody>
              </Table>
            </Paper>
          )}
        </div>
      </div>
    </div>
  );
};
